<template>
  <div class="switch-box">
    <Dropdown trigger="click" style="margin-left: 20px">
      <a href="javascript:void(0)">
        {{lang ? '简体中文' : 'English'}}
        <Icon type="ios-arrow-down"></Icon>
      </a>
      <DropdownMenu slot="list">
        <DropdownItem name="1" :selected="lang ? true : false" @click.native="selectLang(true)" >简体中文</DropdownItem>
        <DropdownItem name="0" :selected="lang ? false : true" @click.native="selectLang(false)" >English</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this.lang);
  },
  methods: {
    ...mapActions(["setUser", "GetCode", "UserMobileLogin" ,"SetLang"]),
    selectLang(e) {
      this.SetLang(e)
    }
  },
  computed: mapGetters({
    words: "words",
    lang: "lang"
  })
};
</script>



<style lang="scss" scoped>
.switch-box {
}
</style>